import { render, staticRenderFns } from "./SurveyInsightsSection.vue?vue&type=template&id=74b09032"
import script from "./SurveyInsightsSection.vue?vue&type=script&lang=js"
export * from "./SurveyInsightsSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports